"use client";

import {
  ErrorDisplay,
  type ErrorDisplayProps,
} from "@shared-components/error-display";

export default function GlobalError(props: ErrorDisplayProps) {
  return (
    <html>
      <body>
        <ErrorDisplay {...props} />
      </body>
    </html>
  );
}
